import React, { useEffect, useState } from 'react'
import className from 'classnames'
import scrollTo from 'gatsby-plugin-smoothscroll'
import * as style from './scroll-button.module.scss'

const ScrollUpButton = () => {
  const [visible, setVisible] = useState(false)
  const onScroll = () => {
    const height = window.innerHeight * 2
    const scrollCheck = window.scrollY > height

    if (scrollCheck !== visible) {
      setVisible(scrollCheck)
    }
  }
  useEffect(() => {
    document.addEventListener('scroll', onScroll)

    return () => {
      document.removeEventListener('scroll', onScroll)
    }
  }, [visible, setVisible])

  return (
    <div className={className(style.wrap, 'scroll-button')}>
      <button
        aria-label="scroll to top"
        className={className(style.button, visible && style.visible)}
        onClick={() => scrollTo('#main-block')}
        onKeyDown={() => scrollTo('#main-block')}
        type="button"
      />
    </div>
  )
}

export default ScrollUpButton
